// import { isLiveEntity } from './isLiveEntity'
import { isUsingMockApi } from './isUsingMockApi'
import { getEntityIdPrefix } from './getEntityIdPrefix'
import type { TEntityId } from '~/types/models'
import { newResourceId } from '~/services/resourceId'
import { useEntityIdSerialNumberStore } from '~/stores/entityIdSerialNumber'

interface IGetNextEntityId {
  entityName: string
}

export function getNextEntityId(o: IGetNextEntityId): TEntityId {
  function _getNextEntityIdLive(o: IGetNextEntityId): TEntityId {
    const rawId = newResourceId()
    // const snPrefix = getEntityIdPrefix(o.entityName)
    // return snPrefix + '-' + rawId
    return rawId
  }
  function _getNextEntityIdMock(o: IGetNextEntityId): TEntityId {
    useEntityIdSerialNumberStore().increment()
    const realIdPrefix = 'XX'
    const sn = useEntityIdSerialNumberStore().getSerialNumber
    const snPrefix = getEntityIdPrefix(o.entityName)
    return (realIdPrefix +
      snPrefix +
      sn.toString().padStart(4, '0')) as TEntityId
  }

  return isUsingMockApi() ? _getNextEntityIdMock(o) : _getNextEntityIdLive(o)
}
